/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useMemo } from 'react';
import { Text, View } from 'react-native';
import type { CashScreenMode } from './cashManagement.types';
import { cashStyles } from './cashManagement.styles';
import { CashUnderlineTabBar } from './CashUnderlineTabBar';

type Props = {
  mode: CashScreenMode;
  onModeChange: (mode: CashScreenMode) => void;
  readOnly?: boolean;
  showHistorial?: boolean;
  showCartera?: boolean;
  /** Hay cierres con diferencia (7 d) — solo punto en tab, sin texto. */
  cierresNeedsAttention?: boolean;
};

/** Mobile / tablet: Turno | Cartera | Historial con tabs cult-ui (sin segmento compacto). */
export function CashModeChrome({
  mode,
  onModeChange,
  readOnly,
  showHistorial = true,
  showCartera = false,
  cierresNeedsAttention,
}: Props) {
  const options = useMemo(() => {
    const items: Array<{ value: CashScreenMode; label: string; attention?: boolean }> = [
      { value: 'turno', label: 'Turno' },
    ];
    if (showCartera) items.push({ value: 'cartera', label: 'Cartera' });
    if (showHistorial) {
      items.push({ value: 'historial', label: 'Historial', attention: cierresNeedsAttention });
    }
    return items;
  }, [showCartera, showHistorial, cierresNeedsAttention]);

  return (
    <View style={cashStyles.modeChrome}>
      <CashUnderlineTabBar options={options} value={mode} onChange={onModeChange} fillTabs />
      {readOnly ? (
        <Text style={cashStyles.readOnlyMobileStrip} accessibilityRole="text">
          Solo lectura — pedí permiso de edición para abrir o cerrar caja.
        </Text>
      ) : null}
    </View>
  );
}
